import { FC } from "preact/compat";
import { FilesPackPreviewProps } from "./interfaces";
import cn from "classnames";

const FilesPackPreview: FC<FilesPackPreviewProps> = ({
    files,
    className,
    itemClassName,
}) => (
    <div className={className}>
        {files.value.map((file) => (
            <div
                key={file.id}
                className={cn(
                    "relative flex-shrink-0 overflow-hidden rounded-2xl",
                    itemClassName,
                )}
            >
                <img
                    src={file.thumbnails[0]}
                    alt=""
                    className="h-full w-full object-cover"
                />
                <div className="absolute left-0 top-0 w-full truncate rounded-t-2xl bg-black/60 p-1 text-center text-xs text-white">
                    {file.name}
                </div>
                {file.thumbnails.length > 1 && (
                    <div className="absolute bottom-0 left-0 grid w-full grid-cols-3 gap-x-1 bg-black/60 p-1">
                        {file.thumbnails.slice(1, 4).map((thumbnail, idx) => (
                            <img
                                key={idx}
                                src={thumbnail}
                                alt=""
                                className="size-8 h-full w-full rounded object-cover"
                            />
                        ))}
                    </div>
                )}
            </div>
        ))}
    </div>
);

export default FilesPackPreview;
